import { checkDateValidity } from '../../../../Foundation/utils';
import { ACTION_DATE_FIELDS } from '../constants/actionDateFields';

/**
 * Returns true when the column is the loss and damage warranty column and the item has loss and damage already used.
 *
 * @param {string|null} columnKey - item date field
 * @param {object}      item      - API row data
 */
export function isLossAndDamageUsed(columnKey, item) {
  return columnKey === ACTION_DATE_FIELDS.lostAndDamage.field && !!item?.IsLossAndDamageUsed;
}

/**
 * Returns true when the out-of-warranty service is disabled for earmoulds (setting enabled),
 * the item is an earmould and its warranty for the given repair/remake action has already ended.
 *
 * @param {string|null}  flowType - flow key from ACTION_DATE_FIELDS (restricted when blockExpiredEarmoulds is set)
 * @param {object}       item     - API row data
 * @param {object}       config   - table config (DisableOutOfWarrantyServiceForEarmolds, EarmouldProductGroupCode)
 */
export function isEarmouldDisabledForFlow(flowType, item, config) {
  const flowConfig = flowType ? ACTION_DATE_FIELDS[flowType] : null;
  if (
    !config?.DisableOutOfWarrantyServiceForEarmolds ||
    !flowConfig?.blockExpiredEarmoulds ||
    !config.EarmouldProductGroupCode ||
    item?.ProductGroupCode !== config.EarmouldProductGroupCode
  ) {
    return false;
  }

  const value = item[flowConfig.field];
  const date = value ? new Date(value) : null;
  if (!checkDateValidity(date)) return false;

  return date < new Date();
}

/**
 * Returns true when the flow's warranty date in the item is a valid date
 *
 * @param {string|null} flowType - flow key from ACTION_DATE_FIELDS
 * @param {object}      item     - API row data
 */
export function hasValidFlowDate(flowType, item) {
  const config = flowType && item ? ACTION_DATE_FIELDS[flowType] : null;
  if (!config) return false;

  const date = item[config.field] ? new Date(item[config.field]) : null;
  return checkDateValidity(date);
}

/**
 * Returns true when the flow is configured with hideExpired and the flow's
 * warranty date in the item is missing, invalid (e.g. 0001-01-01) or in the past.
 *
 * @param {string|null} flowType - flow key from ACTION_DATE_FIELDS (e.g. 'extendWarranty')
 * @param {object}      item     - API row data
 */
export function isExpiredForFlow(flowType, item) {
  if (!flowType || !item) return false;

  const config = ACTION_DATE_FIELDS[flowType];
  if (!config || !config.hideExpired) return false;

  const date = item[config.field] ? new Date(item[config.field]) : null;
  if (!checkDateValidity(date)) return true;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
}
